<template>
  <Cms :pageTitle="'Conteúdo da Página de Parques'" :pageName="'parks'"></Cms>
</template>
<script>
import Cms from '@/pages/cms/Cms'
export default {
  name: 'ParksCms',
  components: {Cms}
}
</script>



// WEBPACK FOOTER //
// ParksCms.vue?03149e0e